import { render, staticRenderFns } from "./CompressLoaderModal.vue?vue&type=template&id=706c4ad6&scoped=true"
import script from "./CompressLoaderModal.vue?vue&type=script&lang=js"
export * from "./CompressLoaderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c4ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('706c4ad6')) {
      api.createRecord('706c4ad6', component.options)
    } else {
      api.reload('706c4ad6', component.options)
    }
    module.hot.accept("./CompressLoaderModal.vue?vue&type=template&id=706c4ad6&scoped=true", function () {
      api.rerender('706c4ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser/modals/CompressLoaderModal.vue"
export default component.exports